import React from 'react';
import { WrapRootElementBrowserArgs } from 'gatsby';
import { Provider } from 'react-redux';
import { StoreType } from './store';

interface RootWrapperProps extends WrapRootElementBrowserArgs {
  store: StoreType;
}

const RootWrapper = ({
  element,
  store,
}: RootWrapperProps): React.ReactElement => {
  return <Provider store={store}>{element}</Provider>;
};

export default RootWrapper;
